import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import setMailboxJunkEmailConfigurationOperation from 'owa-service/lib/operation/setMailboxJunkEmailConfigurationOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function saveMailboxJunkEmailConfiguration(
    options: MailboxJunkEmailConfigurationOptions
): Promise<MailboxJunkEmailConfigurationOptions> {
    return setMailboxJunkEmailConfigurationOperation({
        Header: getJsonRequestHeader(),
        Options: options,
    });
}
